import { FC } from 'react';
import { Box, Typography } from '@mui/material';

import useTranslates from 'utils/translate';

import Sport from 'components/common/icons/Sport';
import SportLiveIcon from 'components/common/icons/SportLive';
import SportResultIcon from 'components/common/icons/SportResult';
import SportBetSlipIcon from 'components/common/icons/SportBetSlip';
import MobileNavigation from 'components/sections/Navigation/Mobile';

import sx from './styles';

export enum SportNavigation {
  live = 'live',
  sport = 'sport',
  betslip = 'betslip',
  results = 'results',
  favorites = 'favorites',
  schedule = 'schedule',
  cybersports = 'cybersports',
}

interface MobileSportFooterProps {
  onLiveClick: () => void;
  onSportClick: () => void;
  onResultsClick: () => void;
  onToggleClick: () => void;
  currentPage: SportNavigation;
}

const MobileSportFooter: FC<MobileSportFooterProps> = ({
  onLiveClick,
  currentPage,
  onSportClick,
  onResultsClick,
  onToggleClick,
}) => {
  const { translate } = useTranslates();

  return (
    <MobileNavigation
      headerVisible={false}
      footerNavigation={
        <>
          <Box onClick={onLiveClick} sx={sx.navButton({ selected: currentPage === SportNavigation.live })}>
            <SportLiveIcon sx={{ fontSize: 24 }} />
            <Typography>{translate('live')}</Typography>
          </Box>
          <Box
            onClick={onSportClick}
            sx={sx.navButton({
              selected: currentPage === SportNavigation.sport || currentPage === SportNavigation.schedule,
            })}
          >
            <Sport sx={{ fontSize: 24 }} />
            <Typography>{translate('sport')}</Typography>
          </Box>
          <Box onClick={onResultsClick} sx={sx.navButton({ selected: currentPage === SportNavigation.results })}>
            <SportResultIcon />
            <Typography>{translate('results')}</Typography>
          </Box>
          <Box onClick={onToggleClick} sx={sx.navButton({ selected: currentPage === SportNavigation.betslip })}>
            <SportBetSlipIcon />
            <Typography>{translate('betslip')}</Typography>
          </Box>
        </>
      }
    />
  );
};

export default MobileSportFooter;
